import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      title: "Ryan Roe | Digital Resume",
      dynamicParam: "-",
      metaTags: [
        {
          name: "description",
          content: "",
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Page Not Found",
    meta: {
      title: "Page Not Found",
      dynamicParam: "-",
      metaTags: [
        {
          name: "description",
          content: "Page not found, return to homepage.",
        },
        {
          property: "og:description",
          content: "Page not found, return to homepage.",
        },
      ],
    },
    component: () => import("../views/NotFound.vue"),
  },
  // ---------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------
];

// ---------------------------------------------------------------------------------
// ---------------------------------------------------------------------------------

const scrollBehavior = (to, from, savedPosition) => {
  if (to.hash) {
    setTimeout(() => {
      const element = document.getElementById(to.hash.replace(/#/, ""));
      if (element && element.scrollIntoView) {
        element.scrollIntoView({
          block: "end",
          behavior: "smooth",
        });
      }
    }, 500);
    return {
      el: to.hash,
    };
  } else if (savedPosition) {
    return savedPosition;
  }
  return {
    top: 0,
  };
};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  // window.console.log(to.path)
  // if (localStorage.getItem('roleID') === null && to.path != '/login') {
  //   window.location.href = '/login'
  // }

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title && r.meta.dynamicParam);
  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    if (
      nearestWithTitle.meta.dynamicParam == undefined ||
      nearestWithTitle.meta.dynamicParam == "-"
    ) {
      document.title = nearestWithTitle.meta.title;
    } else {
      const pageTitle = nearestWithTitle.meta.title.replace(
        ":" + nearestWithTitle.meta.dynamicParam,
        to.params[nearestWithTitle.meta.dynamicParam]
          .replace(/[^a-zA-Z0-9]/g, " ")
          .replace(/\b[a-z]/g, (x) => x.toUpperCase())
      );
      document.title = pageTitle;
    }
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));
  next();
});

export default router;
